var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.23 66.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M10.3 3.39c2.8-2.45 5.85-2.58 8.5 0 2.44 2.38 4.88 4.75 7.26 7.19 2.81 2.88 2.8 5.87.05 8.81-1 1.09-2.14 2.09-3.15 3.19-1.69 1.84-1.83 4.16-.1 5.92q7.82 8 15.81 15.83a4.1 4.1 0 0 0 5.78 0c1.23-1.07 2.31-2.3 3.5-3.43 2.6-2.45 5.58-2.61 8.17-.2 2.75 2.56 5.42 5.22 8 8 2.31 2.49 2.09 5.45-.18 8-3.8 4.3-10.47 9.45-19.94 8.69-6.41-1.21-11-5.2-15.3-9.74q-8.29-8.7-17-17C7.11 34.25 3 29.68 1.79 23.2.12 15 6 7.14 10.3 3.39M8.74 5.45l15.21 15.46m22.93 22.05 15.21 15.46",
    "data-name": "Layer 61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f1326541a7262af807abcb5ff6c44d5e.svg";
export { ForwardRef as ReactComponent };